var lydz = {


    paichepaisiji: {
        name: '派车派司机',
        key: 'paichepaisiji',
    },

    qianzi: {
        name: '负责人签字',
        key: 'qianzi',

    },
    jieshu: {
        name: '结束工单',
        key: 'jieshu',


    },
    feiyongqianzi: {
        name: '费用签字',
        key: 'feiyongqianzi',


    },
    empty: {},
};

export default lydz;


// WEBPACK FOOTER //
// ./src/components/diaodu/forms/rule.js